/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import CollectionModule from 'bundles/page-config-common/components/shared/CollectionModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { useHeaderLevel } from 'bundles/page-config-common/contexts/HeaderLevelContext';
import { useEnterpriseAssignedCoursesCollections } from 'bundles/page-config-common/contexts/enterprise/EnterpriseAssignedCoursesCollectionContext';

import _t from 'i18n!nls/consumer-home';

const styles = {
  enterpriseCollectionHeader: css`
    margin-bottom: var(--cds-spacing-300);
  `,
};

const EnterpriseAssignedCoursesModuleRenderer = () => {
  const { isAssignedCoursesCollectionLoading, assignedCoursesCollection } = useEnterpriseAssignedCoursesCollections();
  const { currentLevel, nextLevel } = useHeaderLevel();

  // Ensure assignedCoursesCollection does not have any "null" entries before rendering (API response can include these).
  const filteredAssignedCourses = assignedCoursesCollection && {
    ...assignedCoursesCollection,
    entities: assignedCoursesCollection?.entities
      ?.filter?.((item) => !!item)
      .map((entity) => ({
        ...entity,
        titleComponent: nextLevel as 'h3' | 'h4',
      })),
  };

  if (
    !isAssignedCoursesCollectionLoading &&
    (!assignedCoursesCollection || !assignedCoursesCollection?.entities?.length)
  ) {
    return null;
  }

  return (
    <HomeSection className="PageConfig_EnterpriseAssignedCourses">
      <CollectionModule
        isCollectionLoading={isAssignedCoursesCollectionLoading}
        collection={filteredAssignedCourses}
        customHeader={
          <div css={styles.enterpriseCollectionHeader}>
            <Typography2 variant="titleSmall" component={currentLevel}>
              {_t('Assigned to you')}
            </Typography2>

            <Typography2 component="p" variant="bodyPrimary">
              {_t('The following content has been assigned to you by your organization')}
            </Typography2>
          </div>
        }
      />
    </HomeSection>
  );
};

export default EnterpriseAssignedCoursesModuleRenderer;
